var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Spots eliminados","storeName":"Deleted_spots","sortable":"","canSearch":"","canAdd":false,"canEdit":false,"canDelete":false,"next-link":"/admin/cars","breadcrumbs":[
    {
      text: 'Spots y vehículos',
      disabled: false,
      href: '/admin/deleted_spots'
    },
    {
      text: 'Spots eliminados',
      disabled: false,
      href: '#'
    }
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }